export { default as MarkerDefault } from './marker-default-on.svg'
export { default as MarkerHAvenue } from './marker-havenue-on.svg'
export { default as MarkerKotel } from './marker-kotel-on.svg'
export { default as MarkerYAJA } from './marker-yaja-on.svg'
export { default as MarkerYAM } from './marker-yam-on.svg'
export { default as MarkerAccomodation } from './marker-accomodation.svg'
export { default as MarkerTrain } from './ico-location-train.svg'
export { default as MarkerLeisure } from './ico-location-activity.svg'
export { default as MarkerBus } from './ico-location-bus.svg'

export { default as Train02Icon } from './logo-train-mugunghwa-h-16.svg'
export { default as Train07Icon } from './logo-train-ktx-sancheon-h-16.svg'
export { default as Train08Icon } from './logo-train-itx-saemaul-h-16.svg'
export { default as Train09Icon } from './logo-train-itx-cheongchun-h-16.svg'
export { default as Train16Icon } from './logo-train-ktx-eum-h-16.svg'
export { default as TrainIcon } from './logo-train-ktx-h-16.svg'
export { default as KorailIcon } from './logo-train-korail-h-16.svg'
export { default as Train02IconH20 } from './logo-train-mugunghwa-h-20.svg'
export { default as Train07IconH20 } from './logo-train-ktx-sancheon-h-20.svg'
export { default as Train08IconH20 } from './logo-train-itx-saemaul-h-20.svg'
export { default as Train09IconH20 } from './logo-train-itx-cheongchun-h-20.svg'
export { default as Train16IconH20 } from './logo-train-ktx-eum-h-20.svg'
export { default as TrainIconH20 } from './train-logo-ktx-20.svg'
export { default as KorailIconH20 } from './logo-train-korail-h-20.svg'
export { default as KorailIconWithId } from './korail-logo-with-id'

export { default as MyRoomImage } from './my-room.svg'

export { default as LogoNolWhite } from './logo-nol-white-h-12.svg'
export { default as LogoKorailWhite } from './logo-train-white-h-16.svg'

export { default as YaCare } from './icon-yacare.svg'
